import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an unhandled error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          textAlign: 'center',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          background: '#f8faf9',
          color: '#1a2e26'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '36px 32px',
            maxWidth: '520px',
            width: '100%',
            boxShadow: '0 12px 36px rgba(0,0,0,0.08)',
            border: '1px solid #e1e7e4'
          }}>
            <div style={{ fontSize: '42px', marginBottom: '14px' }}>⚠️</div>
            <h2 style={{ margin: '0 0 10px', fontSize: '20px', fontWeight: 700 }}>काहीतरी त्रुटी आली / Something went wrong</h2>
            <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#556860', lineHeight: 1.5 }}>
              पृष्ठ पुन्हा लोड करा किंवा मुख्य पृष्ठावर जा.<br />
              Please reload the page or return to dashboard.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                type="button"
                onClick={this.handleReload}
                style={{
                  background: '#1b6b47',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 22px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                पुन्हा लोड करा (Reload)
              </button>
              <button
                type="button"
                onClick={() => { window.location.href = '/'; }}
                style={{
                  background: '#f0f4f2',
                  color: '#1b6b47',
                  border: '1px solid #c7d5cd',
                  borderRadius: '8px',
                  padding: '10px 22px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                मुख्य पृष्ठ (Home)
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
